/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { goodLuckCoreEntitiesOrganizationInvitationSchema } from "./organizationInvitationSchema.ts";
import { goodLuckCoreEntitiesOrganizationMemberSchema } from "./organizationMemberSchema.ts";
import { goodLuckCoreEntitiesOrganizationStreamerSchema } from "./organizationStreamerSchema.ts";
import { goodLuckCoreEntitiesOrganizationSubscriptionSchema } from "./organizationSubscriptionSchema.ts";
import { goodLuckCoreEntitiesOrganizationTwitchAuthSchema } from "./organizationTwitchAuthSchema.ts";
import { goodLuckCoreEntitiesUserSchema } from "./userSchema.ts";
import { z } from "zod/v4";

export const goodLuckCoreEntitiesOrganizationSchema = z.object({
  id: z.optional(z.uuid()),
  name: z.string().min(1).max(100),
  url: z.string().max(50).nullish(),
  tag: z.string().max(10).nullish(),
  description: z.string().nullish(),
  avatarUrl: z.string().nullish(),
  bannerUrl: z.string().nullish(),
  ownerId: z.string().min(1),
  get owner() {
    return goodLuckCoreEntitiesUserSchema.optional();
  },
  discordServerId: z.string().nullish(),
  discordUrl: z.string().nullish(),
  twitterUrl: z.string().nullish(),
  twitchUrl: z.string().nullish(),
  youtubeUrl: z.string().nullish(),
  websiteUrl: z.string().nullish(),
  telegramUrl: z.string().nullish(),
  vkUrl: z.string().nullish(),
  region: z.string().nullish(),
  isPublic: z.optional(z.boolean()),
  allowJoinRequests: z.optional(z.boolean()),
  isVerified: z.optional(z.boolean()),
  hasPremiumFeatures: z.optional(z.boolean()),
  verificationReason: z.string().max(500).nullish(),
  verificationUpdatedAt: z.iso.datetime().nullish(),
  verificationUpdatedByUserId: z.string().max(255).nullish(),
  createdAt: z.optional(z.iso.datetime()),
  updatedAt: z.optional(z.iso.datetime()),
  archivedAt: z.iso.datetime().nullish(),
  get members() {
    return z.array(goodLuckCoreEntitiesOrganizationMemberSchema).nullish();
  },
  get invitations() {
    return z.array(goodLuckCoreEntitiesOrganizationInvitationSchema).nullish();
  },
  get subscriptions() {
    return z
      .array(goodLuckCoreEntitiesOrganizationSubscriptionSchema)
      .nullish();
  },
  get streamers() {
    return z.array(goodLuckCoreEntitiesOrganizationStreamerSchema).nullish();
  },
  get twitchAuth() {
    return goodLuckCoreEntitiesOrganizationTwitchAuthSchema.optional();
  },
});
